import { render, staticRenderFns } from "./WaistList.vue?vue&type=template&id=21e05919&scoped=true&"
import script from "./WaistList.vue?vue&type=script&lang=js&"
export * from "./WaistList.vue?vue&type=script&lang=js&"
import style0 from "./WaistList.vue?vue&type=style&index=0&id=21e05919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e05919",
  null
  
)

export default component.exports